export const firebaseConfig = {
    apiKey: 'AIzaSyCP2iAU-zjFycyIieCAyKwUmBO-XMMGO8o',
    authDomain: 'whereisit-d66b1.firebaseapp.com',
    projectId: 'whereisit-d66b1',
    storageBucket: 'whereisit-d66b1.appspot.com',
    messagingSenderId: '199074098912',
    appId: '1:199074098912:web:b953595df54a3c22b8ea85',
    measurementId: 'G-GLRVKN94M9',
}